import { CustomerTile } from "../components/CustomerTile"
import { Link, useLoaderData } from "react-router-dom";
import { TextField } from "../components/TextField";
import { useEffect, useState } from "react";
import mixpanel from "../services/mixpanel";
import { getUserId } from "../services/helpers";





function renderMembersList(customers){
	return customers.length == 0 ? <h3>No Members meet the search query</h3>
	: customers.map((customer)  =>  <CustomerTile key={`${customer.uuid}${customer.vin}`} customer={customer} />);
  }
export function Members(){
	const {members} = useLoaderData();
	const [searchFilter,setSearchFilter] = useState("");

	let customers = members.members.filter((customer) =>
		`${customer.first_name} ${customer.other_names} ${customer.last_name}`.toLowerCase().includes(searchFilter.trim().toLowerCase())
		|| customer.license_plate?.toLowerCase().includes(searchFilter.trim().toLowerCase()));

		useEffect(()=>{
			mixpanel.identify(getUserId());
		},[]);

	return (
		<main id="Dashboard">
		<h1>Members ({customers.length})</h1>

		<div className="row" id="page-actions">
			{/* <Link>All Members</Link>
			<Link>Active Members</Link>
			<Link>InActive Members</Link> */}
			<TextField
				hint="Name or License Plate"
				value={searchFilter}
				onChange = {(event)=> setSearchFilter(event.target.value)}
			/>

		</div>

		{renderMembersList(customers)}



		</main>
	)
}